import { useEffect, useRef, useState } from "react";

export const queueStorageKey = (userId, sessionId) => userId && sessionId ? `lumanova:composer-queue:v1:${userId}:${sessionId}` : null;
export const queuedJobId = id => `job_${id.replace(/-/g, "")}`;

export function readQueue(key) {
  if (!key) return { items: [], enabled: true };
  try {
    const data = JSON.parse(localStorage.getItem(key) || "{}");
    return { enabled: data.enabled !== false, items: (Array.isArray(data.items) ? data.items : []).filter(item =>
      typeof item.content === "string" && /^[a-f0-9-]{36}$/.test(item.id || "")).slice(0, 20) };
  } catch { return { items: [], enabled: true }; }
}

export async function withQueueLock(key, fn) {
  if (navigator.locks) return navigator.locks.request(key, fn);
  return fn();
}

export function useComposerQueue(userId, sessionId) {
  const key = queueStorageKey(userId, sessionId);
  const keyRef = useRef(key);
  keyRef.current = key;
  const [snapshot, setSnapshot] = useState({ key: null, items: [], enabled: true });
  useEffect(() => {
    const refresh = event => { if (!event || event.key === key) setSnapshot({ key, ...readQueue(key) }); };
    refresh();
    window.addEventListener("storage", refresh);
    return () => window.removeEventListener("storage", refresh);
  }, [key]);
  const mutate = async fn => {
    if (!key) throw Error("请先选择对话");
    return withQueueLock(`${key}:write`, () => {
      const next = fn(readQueue(key));
      localStorage.setItem(key, JSON.stringify(next));
      if (keyRef.current === key) setSnapshot({ key, ...next });
      return next;
    });
  };
  return { key, ...(snapshot.key === key ? snapshot : { items: [], enabled: true }), mutate };
}
